// extracted by mini-css-extract-plugin
module.exports = {"container":"carousel-module--container--7DCR2","slickSlide":"carousel-module--slick-slide--JGVH6","p1":"carousel-module--p1--2NuS-","title":"carousel-module--title--397YA"};